import React, { useState } from 'react';
import { Users, X, ChevronDown, ChevronUp } from 'lucide-react';

const StatistiquesRoles = ({
  title = 'R\u00e9partition par r\u00f4le',
  statsRoles,
  filterRole,
  setFilterRole,
  collapsible = false,
  defaultCollapsed = false
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  if (!statsRoles || statsRoles.length === 0) return null;

  const getColorClass = (index) => {
    const colors = [
      'bg-[#3084b5]/15 text-[#3084b5] border-[#3084b5]/40 hover:bg-[#3084b5]/25',
      'bg-[#319190]/15 text-[#319190] border-[#319190]/40 hover:bg-[#319190]/25',
      'bg-yellow-100 text-yellow-700 border-yellow-300 hover:bg-yellow-200',
      'bg-orange-100 text-orange-700 border-orange-300 hover:bg-orange-200',
      'bg-[#c66d59]/15 text-[#c66d59] border-[#c66d59]/40 hover:bg-[#c66d59]/25',
      'bg-purple-100 text-purple-700 border-purple-300 hover:bg-purple-200',
      'bg-pink-100 text-pink-700 border-pink-300 hover:bg-pink-200',
      'bg-indigo-100 text-indigo-700 border-indigo-300 hover:bg-indigo-200',
    ];
    return colors[index % colors.length];
  };

  const ToggleIcon = isCollapsed ? ChevronDown : ChevronUp;
  const headerClassName = 'flex items-center justify-between ' + (isCollapsed ? 'mb-0' : 'mb-4');
  const gridClassName = 'grid gap-3 ' + (
    statsRoles.length <= 2 ? 'grid-cols-1 sm:grid-cols-2' :
      statsRoles.length <= 3 ? 'grid-cols-1 sm:grid-cols-3' :
        statsRoles.length <= 4 ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4' :
          statsRoles.length <= 5 ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-5' :
            'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6'
  );

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5 mb-6">
      <div className={headerClassName}>
        <div className="flex items-center">
          <Users className="w-5 h-5 mr-2 text-[#246990]" />
          <h3 className="text-base font-semibold text-gray-700">
            {title}
          </h3>
        </div>

        {collapsible && (
          <button
            type="button"
            onClick={() => setIsCollapsed(prev => !prev)}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-gray-200 text-sm text-gray-600 hover:bg-gray-50 transition-colors"
            title={isCollapsed ? 'Afficher' : 'Masquer'}
            aria-expanded={!isCollapsed}
          >
            <span>{statsRoles.length} postes</span>
            <ToggleIcon className="w-4 h-4" />
          </button>
        )}
      </div>

      {!isCollapsed && (
        <>
          <div className={gridClassName}>
            {statsRoles.map((stat, index) => {
              const nbEmployes = parseInt(stat.nombre_employes || 0, 10);
              const filterValue = stat.filter_value || stat.role_nom;
              const isSelected = filterRole === filterValue;
              const cardClassName = 'p-3 rounded-lg border-2 transition-all ' + (
                isSelected
                  ? 'ring-2 ring-[#3084b5] ring-offset-2 shadow-lg '
                  : 'shadow-sm hover:shadow-md '
              ) + getColorClass(index);

              return (
                <button
                  key={filterValue}
                  onClick={() => setFilterRole(isSelected ? '' : filterValue)}
                  className={cardClassName}
                >
                  <div className="text-center">
                    <div className="text-3xl font-bold mb-1">
                      {nbEmployes}
                    </div>
                    <div className="text-sm font-medium leading-tight">
                      {nbEmployes === 1 ? 'employ\u00e9' : 'employ\u00e9s'}
                      <br />
                      {stat.role_nom}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>

          {filterRole !== '' && (
            <div className="mt-4 flex items-center justify-between bg-[#3084b5]/10 border border-[#3084b5]/30 rounded-lg p-3">
              <span className="text-sm font-medium text-[#3084b5]">
                Filtre actif : {statsRoles.find(stat => (stat.filter_value || stat.role_nom) === filterRole)?.role_nom || filterRole}
              </span>
              <button
                onClick={() => setFilterRole('')}
                className="text-sm text-[#3084b5] hover:text-[#1f6a90] font-medium flex items-center bg-white px-3 py-1 rounded-md border border-[#3084b5]/40 hover:bg-[#3084b5]/10 transition-colors"
              >
                <X className="w-4 h-4 mr-1" />
                Réinitialiser
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default StatistiquesRoles;
